import * as React from "react";
function SvgPublicFigure(
  props: React.SVGProps<SVGSVGElement>,
  svgRef?: React.Ref<SVGSVGElement>
) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      ref={svgRef}
      {...props}
    >
      <path d="M.93 9.4A.91.91 0 010 8.47V.93C0 .4.4 0 .93 0h7.54C9 0 9.4.4 9.4.93c0 .54-.4.94-.93.94h-6.6v6.6c0 .6-.34.93-.94.93zM8.47 32H.93a.91.91 0 01-.93-.93v-7.54c0-.53.4-.93.93-.93.54 0 .94.4.94.93v6.6h6.6c.53 0 .93.4.93.94 0 .53-.33.93-.93.93zm22.6-22.6a.91.91 0 01-.94-.93v-6.6h-6.6a.91.91 0 01-.93-.94c0-.53.33-.93.93-.93h7.54c.53 0 .93.4.93.93v7.54c0 .6-.4.93-.93.93zm-17.9 7a7 7 0 115.65 0A10.07 10.07 0 0126 26.08v.84h-5.93v-1.68h4.22A8.36 8.36 0 0016 17.68a8.36 8.36 0 00-8.3 7.55h4.23v1.68H6v-.84c0-4.57 3.03-8.44 7.18-9.66zM31.08 32h-7.54a.91.91 0 01-.93-.93c0-.54.4-.94.93-.94h6.6v-6.6c0-.53.4-.93.94-.93.53 0 .93.4.93.93v7.54c0 .53-.4.93-.93.93zM16 15a5 5 0 100-10 5 5 0 000 10z" />
    </svg>
  );
}
const ForwardRef = React.forwardRef(SvgPublicFigure);
const MemoForwardRef = React.memo(ForwardRef);
export default MemoForwardRef;
